module.exports = __webpack_public_path__ + "static/media/pdf.72eb41ea.svg";